export const arrayUniqueByKey = <T extends object>(
  array: T[],
  key: keyof T,
): T[] => {
  const seen: T[] = [];

  return array.filter((item) => {
    if (seen.some((seenItem) => seenItem[key] === item[key])) {
      return false;
    }

    seen.push(item);

    return true;
  });
};

export const arrayUnique = <T>(array: T[]): T[] => {
  return Array.from(new Set(array));
};

export const arraysAreEqual = (
  a: number[] | undefined,
  b: number[] | undefined,
): boolean => {
  if (a === b) {
    return true;
  }

  if (!a && !b) {
    return true;
  }

  if (!a || !b || a.length !== b.length) {
    return false;
  }

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
};
